import React, { ChangeEvent } from "react";
import { useState } from "react";
import "../../../../styles/formulariodimensiones.css";
import {numerosNaturales} from "../../../../Utils/regex";

const CanalModerno = () => {

  const StyleProps1: React.CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid #ff5100",
  };

  const StyleProps2: React.CSSProperties = {
    color: "black",
  };

  type InfoStructure = {
    guia: string;
    peso: number;
    alto: number;
    ancho: number;
    profundidad: number;
    total: number;
  };

  const InitialValue: InfoStructure = {
    guia: "",
    peso: 0,
    alto: 0,
    ancho: 0,
    profundidad: 0,
    total: 0,
  };

  const [infoToSend, setInfoToSend] = useState(InitialValue);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const HandleInfo = (e: ChangeEvent<HTMLInputElement>, type: string) => {
    if (Number(e.target.value) >= 0) {
      if (type === "guia") {
        if (numerosNaturales(e.target.value)) {
          setInfoToSend({
            ...infoToSend,
            guia: e.target.value,
          });
        }
      }
      if (type === "peso") {
        const toNumber: number = Number(e.target.value);
        setInfoToSend({
          ...infoToSend,
          peso: toNumber,
        });
      }

      if (type === "alto") {
        const toNumber: number = Number(e.target.value);
        setInfoToSend({
          ...infoToSend,
          alto: toNumber,
        });
      }
      if (type === "ancho") {
        const toNumber: number = Number(e.target.value);
        setInfoToSend({
          ...infoToSend,
          ancho: toNumber,
        });
      }

      if (type === "profundidad") {
        const toNumber: number = Number(e.target.value);
        setInfoToSend({
          ...infoToSend,
          profundidad: toNumber,
        });
      }
      if (type === "total") {
        const toNumber: number = Number(e.target.value);
        setInfoToSend({
          ...infoToSend,
          total: toNumber,
        });
      }
    }
  };


  return (
    <div className="invoice-detail-terms">
      <div className="row">
        <div className="col-md-2">
          <div className="form-group mb-2">
            <div>
              <div className="form-group mb-3 text-center">
                <label htmlFor="text" style={StyleProps2}>
                  Guia/Factura
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="number"
                  style={StyleProps1}
                  onChange={(e) =>{}}
                  // onChange={(e) => HandleInfo(e, "guia")}
                  value={infoToSend.guia}
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-2">
          <div className="form-group mb-2">
            <div>
              <div className="form-group mb-3 text-center">
                <label htmlFor="text" style={StyleProps2}>
                  Kilos
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="number"
                  style={StyleProps1}
                  onChange={(e) =>{}}

                  // onChange={(e) => HandleInfo(e, "peso")}
                  value={infoToSend.peso}
                  placeholder="Peso"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-2">
          <div className="form-group mb-2">
            <div>
              <div className="form-group mb-3 text-center">
                <label htmlFor="text" style={StyleProps2}>
                  M3
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="number"
                  onChange={(e) =>{}}
                  style={StyleProps1}
                  // onChange={(e) => HandleInfo(e, "alto")}
                  value={infoToSend.alto}
                  placeholder="Alto"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-2">
          <div className="form-group mb-2">
            <div>
              <div className="form-group mb-3 text-center">
                <label htmlFor="text" style={StyleProps2}>
                  M3
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="number"
                  onChange={(e) =>{}}
                  style={StyleProps1}
                  // onChange={(e) => HandleInfo(e, "ancho")}
                  value={infoToSend.ancho}
                  placeholder="Ancho"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-2">
          <div className="form-group mb-2">
            <div>
              <div className="form-group mb-3 text-center">
                <label htmlFor="text" style={StyleProps2}>
                  M3
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="number"
                  onChange={(e) =>{}}
                  style={StyleProps1}
                  // onChange={(e) => HandleInfo(e, "profundidad")}
                  value={infoToSend.profundidad}
                  placeholder="Profundidad"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-2">
          <div className="form-group mb-2">
            <div>
              <div className="form-group mb-3 text-center">
                <label htmlFor="text" style={StyleProps2}>
                  M3
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="number"
                  onChange={(e) =>{}}
                  style={StyleProps1}
                  // onChange={(e) => HandleInfo(e, "total")}
                  value={infoToSend.total}
                  placeholder="Total"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CanalModerno;
